import {z} from 'zod';
import {date, id, time} from '../global/globalModels';
import {baseTeam} from '../team/teamModel';
import {bookingRuleStatus, weekDay} from './bookingRule';

const selectView = z.object({
    id: id,
    name: z.string(),
});

export const priorityBookingRuleBase = z.object({
    status: bookingRuleStatus,
    title: z.string(),
    dateFrom: date,
    dateUntil: date.nullable(),
    comment: z.string().nullable(),
    weekDays: z.array(weekDay),
    locations: z.array(z.string()),
    floors: z.array(z.string()),
    rooms: z.array(z.string()),
    resources: z.array(z.string()).optional().default([]),
    resourceTypes: z.array(z.string()),
    allowedToEdit: z.boolean(),
    target: z
        .object({
            teams: baseTeam.array(),
            users: selectView.array(),
        })
        .optional(),
    releaseTime: time.nullable(),
    releaseDays: z.number().nullable(),
});

export type priorityBookingRuleBase = z.infer<typeof priorityBookingRuleBase>;

export const priorityBookingRuleCreate = priorityBookingRuleBase;

export type PriorityBookingRuleCreate = z.infer<typeof priorityBookingRuleCreate>;

export const priorityRule = z.object({
    priority: z.boolean(),
    reason: z.string(),
    until: z.coerce.date().nullable(),
});

export type PriorityRule = z.infer<typeof priorityRule>;

export const priorityBookingRule = z.intersection(priorityBookingRuleCreate, z.object({id: id}));

export type PriorityBookingRule = z.infer<typeof priorityBookingRule>;

export const priorityRuleValidation = z.object({
    excludedResources: z.number(),
    locations: id.array(),
    floors: id.array(),
    rooms: id.array(),
});

export type PriorityRuleValidation = z.infer<typeof priorityRuleValidation>;

export type PriorityBookingRuleActive = {
    title: string;
    dateUntil: Date | null;
    comment: string | null;
};
